const actions = {
  SET_STATE: "dashboard/SET_STATE",
  STATS: "dashboard/STATS",
};

export default actions;
